<template>
    <main>
        <modalInformacionUsuario :usuario="usuario"></modalInformacionUsuario>
        <page-header-compact>
            <span class="d-block">Historial de historias Clinicas</span>
            <template v-slot:button>
                <router-link :to="{ name: 'historias.perfil.usuario', params: { idUsuario: usuario.id } }"
                    class="btn btn-success btn-sm shadow-sm mx-2">
                    Regresar al perfil del paciente <i class="fas fa-history fa-fw"></i>
                </router-link>
            </template>
        </page-header-compact>
        <div class="container-xl px-4">
            <div class="card mt-2">
                <cardInformacionUsuario :usuario="usuario"></cardInformacionUsuario>
            </div>
            <div class="card mt-2 mb-4 card-collapsable shadow-sm border-0">
                <a class="card-header bg-transparent border-bottom-0 pt-3 pb-3" href="#collapseFilters" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseFilters">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-filter text-gray-400 mr-2 fa-fw"></i>
                        <h5 class="mb-0 font-weight-700 text-gray-700">Búsqueda y Filtros</h5>
                    </div>
                    <div class="card-collapsable-arrow">
                        <i class="fas fa-chevron-down text-gray-400"></i>
                    </div>
                </a>
                <div class="collapse hide" id="collapseFilters">
                    <div class="card-body pt-0">
                        <div class="row align-items-end">
                            <div class="col-lg-8 form-group mb-3">
                                <label class="small font-weight-700 text-gray-600 mb-1">Sede</label>
                                <auto-complete-sede v-model="sede"></auto-complete-sede>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 form-group mb-3">
                                <label class="small font-weight-700 text-gray-600 mb-1">Fecha</label>
                                <input type="date" class="form-control form-control-sm border-gray-300" v-model="pagination.params.fecha" />
                            </div>
                            <div class="col-lg-5 col-md-6 col-sm-12 form-group mb-3">
                                <label class="small font-weight-700 text-gray-600 mb-1">Profesional</label>
                                <v-select-user v-model="pagination.params.id_user"></v-select-user>
                            </div>
                            <div class="col-lg-4 col-md-12 col-sm-12 form-group mb-3">
                                <label class="small font-weight-700 text-gray-600 mb-1">Tipo de Atención</label>
                                <select v-model="pagination.params.id_tipo_historia" class="form-control form-control-sm border-gray-300">
                                    <option :value="item.id" v-for="item in tipos_historias" :key="item.id">{{item.nombre}}</option>
                                </select>
                            </div>
                            <div class="col-lg-3 col-md-12 col-sm-12 form-group mb-3 text-right">
                                <button class="btn btn-primary btn-sm px-4 mr-2 shadow-none" @click="cargarHistorias(id_usuario)">
                                    <i class="fas fa-search mr-2"></i> Buscar
                                </button>
                                <button class="btn btn-light btn-sm px-4 text-gray-600 border-gray-300 shadow-none font-weight-700" @click="resetFilters()">
                                    <i class="fas fa-broom mr-2"></i> Limpiar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-2">
                <div class="card-body">
                    <div class="alert alert-warning" v-show="!pagination.data.length">Sin historial de atenciones...</div>
                    <data-grid :data="pagination" @changePage="changePage($event)"
                        @perPageChange="perPageChange($event)" @search="search($event)" :searchBox="false">
                        <template #grid>
                                <div class="card mb-3 shadow-sm border-left-lg overflow-hidden"
                                    v-for="(item, i) in pagination.data" :key="`d_${i}`"
                                    :class="{ 'border-left-success': item.finalizada === 'S', 'border-left-warning': item.finalizada === 'N' }">
                                   
                                    <!-- Card Header: High-Density Compact Layout with Separators -->
                                    <div class="card-body bg-light py-3 px-4">
                                        <div class="row no-gutters align-items-center">
                                            <!-- Primary ID -->
                                            <div class="col-md-6 col-sm-12 col-xs-12 col-lg-auto d-flex align-items-center mr-lg-4 mb-2 mb-lg-0">
                                                <span class="text-xs text-gray-600 font-weight-700 uppercase tracking-wider mr-2">HC No.</span>
                                                <span class="h5 mb-0 font-weight-500 text-primary">{{ item.id }}</span>
                                            </div>
                                            
                                            <!-- Type Badge -->
                                            <div class="col-md-6 col-sm-12 col-xs-12 col-lg-auto d-flex align-items-center mb-2 mb-lg-0 responsive-border pl-lg-4 mr-lg-4">
                                                <span class="badge badge-secondary-soft badge-marketing text-gray-700 font-weight-700 border-0 shadow-none px-3" style="font-size: 0.65rem;">
                                                    {{ item.tipo_historia.nombre }}
                                                </span>
                                            </div>

                                            <!-- Date Info -->
                                            <div class="col-md-6 col-sm-12 col-xs-12 col-lg-auto d-flex align-items-center responsive-border pl-lg-4 mr-lg-4 text-gray-600">
                                                <i class="far fa-calendar-alt mr-2 opacity-50"></i>
                                                <span class="small font-weight-600">{{ item.created_at | formatDateTime }}</span>
                                            </div>

                                            <!-- Status Info -->
                                            <div class="col-md-6 col-sm-12 col-xs-12 col-lg-auto d-flex align-items-center responsive-border pl-lg-4">
                                                <div :class="item.finalizada === 'S' ? 'text-success' : 'text-warning'" class="small font-weight-700 d-flex align-items-center">
                                                    <i class="fas fa-circle mr-2" style="font-size: 0.45rem; opacity: 0.6;"></i>
                                                    {{ item.finalizada === 'S' ? 'Finalizada' : 'Sin Finalizar' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body px-4">
                                            <div class="x-small text-gray-600">
                                                <div v-if="!item.impresion_diagnostica" class="alert alert-warning">
                                                    <i class="fas fa-exclamation-triangle"></i> Historia clínica sin Diagnóstico
                                                </div>
                                                <div v-else>
                                                    <span class="text-xs font-weight-700 text-gray-500 uppercase">Impresión Diagnóstica:</span>
                                                    <ul class="mb-0 mt-1 pl-3 text-bold">
                                                        <li v-for="(diag,index) in item.impresion_diagnostica.items" :key="index" class="mb-1">
                                                            <strong class="">{{ diag.diagnostico.ID_DIAG }}</strong> {{ diag.diagnostico.DESC_DIAG }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                        <hr class="my-3" style="border-color: #e3e6ec;">

                                        <!-- Documentation Actions -->
                                        <div class="mb-2">
                                            <div class="text-xs font-weight-600 text-gray-500 uppercase mb-2" style="font-size: 0.55rem;">Acciones Clínicas</div>
                                            <div class="d-flex flex-wrap" style="gap: 4px;">
                                                <button @click="imprimir(item.id);" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Imprimir Historia">
                                                    <i class="fas fa-print text-primary fa-fw"></i>H.C Completa
                                                </button>
                                                <button @click="resumen(item.id);" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Resumen">
                                                    <i class="fas fa-file-invoice text-indigo fa-fw"></i>{{ item.tipo_historia.codigo!=='URG' ? 'Resumen' : 'Epicrisis' }}
                                                </button>
                                                <button v-if="item.formulas && item.formulas.length" @click="formulaModal(item.id);" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Fórmula médica">
                                                    <i class="fas fa-pills text-red fa-fw"></i>Fórmulas
                                                </button>
                                                <button v-if="item.remisiones && item.remisiones.length" @click="abrirModal(item.id)" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Remisiones">
                                                    <i class="fas fa-share-square text-teal fa-fw"></i>Remisiones
                                                </button>
                                                <button v-if="item.evoluciones && item.evoluciones.length" @click="EvolucionModal(item.id)" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Evoluciones">
                                                    <i class="fas fa-history text-orange fa-fw"></i>Evoluciones
                                                </button>
                                                <button v-if="item.incapacidades && item.incapacidades.length" @click="IncapacidadModal(item.id)" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Incapacidades">
                                                    <i class="fas fa-user-md text-cyan fa-fw"></i>Incapacidades
                                                </button>
                                                <button @click="openModalNotasEnfermeria(item.id_usuario)" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Notas de enfermeria">
                                                    <i class="fas fa-notes-medical text-purple fa-fw"></i>Notas Enfermería
                                                </button>
                                                <button v-if="item.ordenes && item.ordenes.length" @click="ordenModal(item.id, 'procedimiento');" class="btn btn-xs btn-light text-gray-600 font-weight-600 border-gray-200" title="Orden médica">
                                                    <i class="fas fa-clipboard-list text-pink fa-fw"></i>Ord. Procedimientos
                                                </button>
                                                <button v-if="item.ordenes && item.ordenes.length && item.tipo_historia.codigo === 'URG'" @click="ordenModal(item.id, 'medicamento');" class="btn btn-xs btn-light text-gray-600 font-weight-700 border-gray-200" title="Orden médica">
                                                    <i class="fas fa-prescription-bottle-alt text-green fa-fw"></i>Ord. Médicas
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Footer: Metadata & Admin Actions -->
                                    <div class="card-footer bg-transparent border-top-0 pt-0 pb-3 d-flex align-items-center justify-content-between px-4">
                                        <div class="d-flex flex-wrap align-items-center x-small font-weight-700 text-gray-600 uppercase tracking-tighter" style="font-size: 0.7rem;">
                                            <span class="mr-3"><i class="fas fa-user-md fa-fw"></i> {{ item.user.name }}</span>
                                            <span v-if="item.sede"><i class="fas fa-map-marker-alt fa-fw"></i> {{ item.sede.NOMBRE_SEDE }}</span>
                                        </div>
                                                                  <div>
                                         <!-- Caso 1: No tiene log O es CONSULTA y falló (Permite abrir para corregir) -->
                                         <div class="d-flex btn-group flex-wrap align-items-center" v-if="!item.ihce_log || (item.ihce_log.type_rda === 'CONSULTA' && item.ihce_log.status === 'failed')">
                                             <span v-if="item.ihce_log && item.ihce_log.status === 'failed'" class="badge badge-danger-soft mr-2" title="El envío a IHCE falló, abra la historia para corregir">
                                                 <i class="fas fa-exclamation-triangle mr-1"></i> Envío IHCE Fallido
                                             </span>
                                             <button class="btn btn-xs btn-outline-success px-4 shadow-none transition-all"
                                                     v-if="item.id_user === user.id && (item.finalizada === 'S' || item.ingreso === 'finalizado')"
                                                     @click="openModalHC(item)" title="Abrir Historia">
                                                     <i class="fas fa-folder-open mr-2"></i> Abrir HC
                                             </button>
                                         </div>
                                         <!-- Caso 2: Enviada con éxito a IHCE -->
                                         <div class="d-flex btn-group flex-wrap align-items-center" v-else-if="item.ihce_log && item.ihce_log.status === 'success'">
                                             <span class="badge badge-success-soft mr-2">Historia {{item.id}} enviada a IHCE</span>
                                             <span class="badge badge-info-soft">Fecha: {{ item.ihce_log.created_at | formatDateTime}}</span>
                                         </div>
                                         <!-- Caso 3: Falló pero es de otro tipo RDA que no permite edición -->
                                         <div class="d-flex btn-group flex-wrap align-items-center" v-else>
                                             <span class="badge badge-danger-soft mr-2">Envío IHCE Fallido ({{ item.ihce_log ? item.ihce_log.type_rda : '' }})</span>
                                             <span v-if="item.ihce_log" class="badge badge-info-soft">Fecha: {{ item.ihce_log.created_at | formatDateTime}}</span>
                                         </div>
                                       </div>
                                    </div>
                                </div>
                        </template>
                    </data-grid>
                    <modal-remisiones ref="modalRemisiones"></modal-remisiones>
                    <modal-ordenes ref="modalOrdenes"></modal-ordenes>
                    <modal-formulas ref="modalFormulas"></modal-formulas>
                    <modal-evoluciones ref="modalEvoluciones"></modal-evoluciones>
                    <modal-incapacidades ref="modalIncapacidades"></modal-incapacidades>
                    <modalOpenHC ref="modalHC"></modalOpenHC>
                    <modalNotasEnfermeria ref="modalNotasEnfermeria"></modalNotasEnfermeria>
                </div>
            </div>
        </div>
    </main>
</template>
<script>

import modalInformacionUsuario from "../../base/informacionUsuario/modalInformacionUsuario";
import cardInformacionUsuario from "../../base/informacionUsuario/cardInformacionUsuario";
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import usuarioService from '../../../../services/usuarioService';
import historiaClinicaService from '../../../../services/historiaClinicaService';
import DataGrid from "../../../../components/common/utilities/DataGrid/DataGrid";
import Toast from '../../../../components/common/utilities/toast';
import modalRemisiones from "./modalRemisiones";
import modalOrdenes from "./modalOrdenes";
import modalFormulas from "./modalFormulas";
import modalEvoluciones from "./modalEvoluciones";
import modalIncapacidades from "./modalIncapacidades";
import modalOpenHC from "./abrirHistoria/modalOpenHC";
import AutoCompleteSede from "../../../../components/common/autocompletes/AutoCompleteSede"
import VSelectUser from "../../../../components/common/vSelectUser";
import tipoHistoriaService from "../../../../services/tipoHistoriaService";
import modalNotasEnfermeria from "./modalNotasEnfermeria";
export default {
    components: {
        modalInformacionUsuario, cardInformacionUsuario, PageHeaderCompact,
        DataGrid, modalRemisiones, modalOrdenes, modalFormulas, modalEvoluciones, modalIncapacidades,
        modalOpenHC,AutoCompleteSede,VSelectUser,modalNotasEnfermeria
    },
    data() {
        return {
            id_usuario: '',
            usuario: {},
            historias: [],
            pagination: {
                data: [],
                current_page: 1,
                page: 1,
                per_page: 5,
                search: '',
                total: '',
                params: {
                    id_user: "",
                    fecha: "",
                    id_sede: "",
                    id_tipo_historia: ""
                },
            },
            sede:{},
            tipos_historias: [],
        }
    },
    methods: {
        async cargarUsuario(id) {
            const response = await usuarioService.show(id);
            this.usuario = response.data;
        },
        async cargarHistorias(id) {
            try {
                this.LoaderSpinnerShow();
                const response = (await historiaClinicaService.showByIdPaciente(this.pagination.search, this.pagination, id))?.data;
                this.pagination.data = response.data;
                this.pagination.current_page = response.current_page;
                this.pagination.total = response.total;
                this.LoaderSpinnerHide();

            } catch (e) {
                console.error(e);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'error',
                    title: 'Ocurrio un error al procesar la solicitud'
                });
            }
        },
        imprimir(id) {
            window.open(historiaClinicaService.print(id));
            //this.$router.push({name : this.rutas_imprimir[tipo], params:{id:id}});
        },
        resumen(id) {
            window.open(historiaClinicaService.resumen(id));
        },
        changePage(page) {
            this.pagination.page = page;
            this.cargarHistorias(this.id_usuario);
        },
        perPageChange(per_page) {
            this.pagination.per_page = per_page;
            this.pagination.page = 1;
            this.cargarHistorias(this.id_usuario);
        },
        search(query) {
            this.pagination.search = query;
            this.pagination.page = 1;
            this.cargarHistorias(this.id_usuario);
        },
        abrirModal(id_historia) {
            this.$refs.modalRemisiones.abrir(id_historia);
        },
        formulaModal(id_historia) {
            this.$refs.modalFormulas.abrir(id_historia);
        },
        ordenModal(id_historia, type) {
            this.$refs.modalOrdenes.abrir(id_historia, type);
        },
        EvolucionModal(id_historia) {
            this.$refs.modalEvoluciones.abrir(id_historia);
        },
        IncapacidadModal(id_historia) {
            this.$refs.modalIncapacidades.abrir(id_historia);
        },
        openModalHC(historia) {
            this.$refs.modalHC.openModal(historia);
        },
        openModalNotasEnfermeria(idUsuario) {
            this.$refs.modalNotasEnfermeria.openModal(idUsuario);
        },
        resetFilters() {
            this.pagination.params.id_user = "";
            this.pagination.params.fecha = "";
            this.pagination.params.id_sede = "";
            this.pagination.params.id_tipo_historia = "";
            this.sede={};
            this.cargarHistorias(this.id_usuario);
        },
        async getTiposHistorias(){
            const response = await tipoHistoriaService.index();
            this.tipos_historias = response.data;
        }
    },
    async created() {
        this.id_usuario = this.$route.params.id;
        await this.cargarUsuario(this.$route.params.id);
        await this.cargarHistorias(this.$route.params.id);
        await this.getTiposHistorias();
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    watch: {
        sede : function (newVal, oldVal) {
            if(newVal.ID !== oldVal.ID){
                this.pagination.params.id_sede = newVal.ID;
            }
        }
    },
}
</script>
<style scoped>
    .cursor-pointer{
        cursor: pointer;
    }
    .link-hover:hover {
        color: #0061f2 !important;
        text-decoration: none;
    }
    @media (min-width: 992px) {
        .responsive-border {
            border-left: 1px solid #e3e6ec;
            padding-left: 1.5rem;
            margin-left: 0.5rem;
        }
    }
</style>